import styled from 'styled-components';
import { ReactComponent as RawLeaderboardsSVG } from '../../../../assets/icons/icon_leaderboards.svg';

export const IconLeaderboards = styled(RawLeaderboardsSVG)``;
